import React, { useState, useContext } from 'react'
import { addAdminActivity, deleteDoc, getStudentById, getStudents, updateDoc } from '../../../firebase/utils'
import { toast } from 'react-toastify';
import Loader from '../../../Common/Component/Loader';
import useFetchUserRoles from "../../../hook";
import { isAccess } from '../../../utils/adminRoles';
import { showAlertDelete, showAlert } from '../../../utils/alert';
import AdminContext from '../../../Helper/admin'
import { Btn } from '../../../AbstractElements';

const TakeActionTab = ({ data, setData, students, setStudents }) => {
  const [loading, setLoading] = useState(false);
  const [bannedLoading, setBannedLoading] = useState(false);
  const hasAccessToBan = useFetchUserRoles('usersBan', isAccess)
  const hasAccessToDelete = useFetchUserRoles('usersDelete', isAccess)
  const { user, location } = useContext(AdminContext)

  const handleBanUser = async (data) => {
   
    let warningText;
    if (data?.banned) {
      warningText = `Are you sure you want to unban ${data?.fullName} Email:${data?.email}`;
    } else {
      warningText = `Are you sure you want to ban ${data?.fullName} Email:${data?.email}`;
    }
    const isConfirm = await showAlert(warningText);
    if (isConfirm) {
      setBannedLoading(true);
      const activityOptions = {
        adminId: user.email,
        activityOnUser: data.email,
        type: !data.banned ? "BAN_USER" : "UNBAN_USER",
        createdAt: new Date(),
        acivity: `${user.email} ${!data.banned ? "banned" : "unBanned"} ${data.email}`,
      };
      await Promise.allSettled([
        addAdminActivity(activityOptions, location),
        updateDoc('users', data.id, {
          banned: !data.banned,
        }),
      ]);

      const updatedStudent = await getStudentById(data?.id);
      if (!updatedStudent) return;

      setStudents((prevStudents) =>
        prevStudents.map((student) =>
          student.id === updatedStudent.id ? updatedStudent : student
        )
      );
      setData(updatedStudent);
      toast.success(`Student ${data.banned ? "Unban" : "ban"} successfully`);
    }
    setBannedLoading(false);
  };
  const deleteStudent = async (data) => {
    const warningText = `Are you sure you want to delete ${data?.fullName} Email:${data?.email}`
    const isConfirm = await showAlertDelete(warningText)
    if (isConfirm) {
      setLoading(true);
      const activityOptions = {
        adminId: user.email,
        activityOnUser: data.email,
        type: "delete_user",
        createdAt: new Date(),
        acivity: `${user.email} deleted ${data.email}`,
      };
      await addAdminActivity(activityOptions, location)
      await deleteDoc('users', data.id)
      setStudents(students.filter((std) => std.id !== data.id))
      toast.success("User deleted successfully");
    }
    setLoading(false);
  };
  return (
    <div style={{ display: "flex" }}>
      <div style={{ marginRight: '8px' }}>
        <Btn attrBtn={{
          color: "info", onClick: () => {
            hasAccessToBan ?
              handleBanUser(data) :
              toast.error("You don't have access, please ask Super Admin to provide you access!");
          }
        }}>{
            bannedLoading ? (
              <Loader />
            ) :
              data?.banned ? (
                "Unban"
              ) : (
                "Ban"
              )}</Btn>
      </div>
      <div>
        <Btn attrBtn={{
          color: "danger", onClick: () => {
            hasAccessToDelete ?
              deleteStudent(data) :
              toast.error("You don't have access, please ask Super Admin to provide you access!");
          }
        }}>{loading ? <Loader /> : "Delete"}</Btn>
      </div>
    </div>
  )
}

export default TakeActionTab